import React from 'react';
import ReactDOM from 'react-dom';

import AnnouncementApp from '../app/components/AnnouncementApp.jsx';

const root = document.getElementById('root-announcement');

if (root) {
  ReactDOM.render((
    <AnnouncementApp />
  ), root);
}
